'use client';

import React, { useEffect, useRef, useState } from 'react';
import './Analytics.scss';
import CountUp from 'react-countup';
import { useInView } from 'framer-motion';

// interface AnalyticsProps {
//   statsJaecooJ7Phev: {
//     id: number;
//     text: string;
//     value: string;
//   }[];
// }

export default function Analytics({ options }) {
  const ref = useRef(null);
  const isInView = useInView(ref);

  const [isView, setIsView] = useState(false);

  useEffect(() => {
    setIsView(true);
  }, [isInView]);

  return (
    <ul className={'analytics'} ref={ref}>
      {options.map((item, index) => (
        <li
          className={'analytics_item'}
          key={item?.fields?.id?.value}
          data-aos="fade-up"
          data-aos-offset="100"
          data-aos-duration={(index + 1) * 500}
        >
          <div className="analytics_item_counter">
            {item?.fields?.isCount?.value && (
              <CountUp
                start={0}
                end={Number(item?.fields?.result?.value)}
                duration={2.5}
                separator=""
                decimals={Number(item?.fields?.result?.value) < 1 ? 2 : 0}
                className={'analytics_item_value'}
              />
            )}
            {!item?.fields?.isCount?.value && (
              <span className={'analytics_item_value'}>{item?.fields?.result?.value}</span>
            )}
            <span className={'analytics_item_units'}>{item?.fields?.units?.value}</span>
          </div>
          <p className={'analytics_item_description'}>{item?.fields?.column?.value}</p>
        </li>
      ))}
    </ul>
  );
}
